import { BaseHttpService } from './base-http.service'

export default new class AuthService extends BaseHttpService {
  login(path: string, params: any): Promise<any> {
    return super.postPromise(path, params);
  }
  register(path: string, params: any): Promise<any> {
    return super.postPromise(path, params);
  }

  logout(path: string, params: any): Promise<any> {
    return super.postPromise(path, params);
  }
}